import crm from './crm';

const EmailService = {
    enviarEmail: (dados, formData=false) => {
        const config = (formData && {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }) || {}
        return crm.post('/conecta/email/enviar', dados, config);
    },
    getAssinatura: () => {
        return crm.get('/perfil-usuario/assinatura');
    },
};

export default EmailService;

